import { IsIn, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

const ALLOWED_STATUSES = ['ACCEPTED', 'ACCEPTED_WITH_RESERVATION', 'REJECTED'] as const;

export class UpdateDeliveryItemStatusDto {
  @IsString()
  @IsNotEmpty()
  @IsIn(ALLOWED_STATUSES)
  status!: 'ACCEPTED' | 'ACCEPTED_WITH_RESERVATION' | 'REJECTED';

  @IsOptional()
  @IsString()
  @OptionalStringTransform()
  reason?: string;
}
